<template>
    <div>
        <!-- Modal -->
        <!-- <failed-search-modal
            :visible="showFailedSearchModal"
            :airports-from="airportsFrom"
            :airports-to="airportsTo"
            @proposeClicked="proposeATrip"
            @notifyClicked="notifySimilarFlight"
            @searchingClicked="keepSearching"
        /> -->
        <propose-a-trip-modal
            :airportFrom="searchFormAirportFrom"
            :airportTo="searchFormAirportTo"
            :errorMessages="errorMessages"
            v-if="showProposeATrip"
            @closeModal="closeModalProposeTrip"
            @optionSelected="storeFailedSearch"/>
        <!-- End Modal  -->
        <div ref="tripContainer" v-if="hasTrips" class="container p-15">
            <div v-if="localTripsLoaded" class="row">
                <div class="col-md-12 d-flex justify-content-center mt-20">
                    <h3> Flights in your area: </h3>
                </div>
            </div>
            <!-- <div v-if="filteredSearch && !filteredSearchWithoutDate" class="row">
                <div class="col-md-12 d-flex text-center justify-content-center mt-20">
                    <h3> {{ searchTitle }} </h3>
                </div>
            </div> -->
            <template v-if="!filteredSearchWithoutDate">
                <div  v-for="trip in trips" :key="trip.id">
                    <!-- Planned Trip -->
                    <template v-if="trip.type == 'Planned'">
                        <planned-trip-card :trip="trip" ></planned-trip-card>
                    </template>
                    <!-- Proposed Trip -->
                    <template v-if="trip.type == 'Proposed'">
                        <proposed-trip-card @guestSetted="getUser" :trip="trip"></proposed-trip-card>
                    </template>
                </div>    
            </template>
        </div>
        <template v-if="filteredSearchWithoutDate && trips.length > 0">
            <trip-table :trips="trips"></trip-table>
        </template>
        <div v-if="!filteredSearchWithoutDate" v-show="hasTrips" class="container">
            <div class="row justify-content-between">
                <div class="col-6 d-flex  justify-content-sm-between">
                    <h5>
                        Showing {{ from + 1 }} to {{ to }} of {{ pagination.total }} Trips
                    </h5>
                </div>
                <base-pagination
                    :per-page="pagination.perPage"
                    :showFirstPageButton="true"
                    :showLastPageButton="true"
                    :total="pagination.total"
                    @input="changePage"
                    class="pagination-no-border col-6 justify-content-end"
                    v-model="pagination.currentPage">
                </base-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import httpClient from '@/utils/httpClient';
    import PlannedTripCard from './Cards/PlannedTripCard';
    import ProposedTripCard from './Cards/ProposedTripCard';
    import paginationOnServerMixin from '../../mixins/paginationOnServerMixin';
    import BasePagination from '../../components/BasePagination';
    // import FailedSearchModal from '../../components/Alerts/FailedSearchModal';
    import ProposeATripModal from '../../components/Alerts/ProposeATripModal';
    import SearchHelpersMixin from '../../mixins/SearchHelpersMixin';
	import GuestMixin from '../../mixins/GuestMixin';
    import PopUpMixin from '../../mixins/dinamicPopUpMixin';
    import TripStatusMixin from '@/mixins/TripStatusMixin'
    import StatisticsMixin from '@/mixins/StatisticMixin'
    import axios from 'axios'
    import TripTable from './Tables/TripTable'
    import { mapState } from "vuex";


    export default {
        mixins: [StatisticsMixin, paginationOnServerMixin, GuestMixin, SearchHelpersMixin, PopUpMixin, TripStatusMixin],
        components: {
            BasePagination,
            // FailedSearchModal,
            PlannedTripCard,
            ProposedTripCard,
            TripTable,
            ProposeATripModal
        },
        props:{
            searchFormAirportFrom: {
                type:Object,
                default:null
            },
            searchFormAirportTo: {
                type:Object,
                default:null
            }
        },
        mounted() {
            if ((Boolean(this.email) || this.authenticated) && this.$route.query && this.$route.query.from) {
                this.initialized = true;
                this.filteredTripFetch(this.$route.query.from, this.$route.query.to, this.$route.query.range);
                this.$emit('queriedFetch');
            } else if (this.authenticated && this.$store.state.users.user.airport_id) {
                this.fetchHomeAreaTrips();
            } else {
                this.fetchAllTrips();
            }
        },
        data() {
            return {
                trips: [],
                airportsFrom: [],
                airportsTo: [],
                searchTitle: '',
                localTripsLoaded: false,
                filteredSearch: false,
                initialized: false,
                lastFetch: {
                    endpoint: '0',
                    from: null,
                    to: null,
                    dateRange: ''
                },
                showProposeATrip:false,
				noFlightsPopUpCode: 'no-flights-found',
                tripCreatedPopUpCode: 'trip-created-after-failed-search',
                filteredSearchWithoutDate:false,
                localUserSetted:false,
                failedSearchNewTrip:null,
                errorMessages:[]
            }
        },
        methods: {
            async closeModalProposeTrip() {
                window.location.replace(process.env.VUE_APP_HOME_PAGE)
            },
            tripStatusSetted(proposeParams) {

                this.storeFailedSearch(proposeParams);
                
               /*  if (this.getStatus('verified') == this.getStatus(status)) {
                    this.closeModalProposeTrip()
                }
                else if (this.getStatus('shared-private') == this.getStatus(status) || this.getStatus('private') == this.getStatus(status) ) {
                    httpClient.patch('/api/trip/'+this.failedSearchNewTrip.id,{ status: this.getStatus(status) })
                    .then(()=>{this.closeModalProposeTrip()})
                } */
            },
            getUser() {
                if (!(this.user && this.user.id) && !this.localUserSetted ) {
                    this.$store.dispatch('users/getUser')   
                }
                this.localUserSetted = true
            },
            fetchTableData() {
                this.scrollToTop();

                if (this.lastFetch.endpoint === 1) {
                    this.fetchHomeAreaTrips();
                } else if (this.lastFetch.endpoint === 2) {
                    this.fetchAllTrips();
                } else if (this.lastFetch.endpoint === 3) {
                    this.filteredTripFetch(this.lastFetch.from, this.lastFetch.to, this.lastFetch.dateRange);
                }
            },
            fetchHomeAreaTrips() {
                this.setLastFetch(1, this.$store.state.users.user.airport_id, null, null);
                // let paginationParams = this.getPaginationParams();
                let url = this.getUrl(this.$store.state.users.user.airport_id, null);
                let params = this.getParams(this.$store.state.users.user.airport_id, null, null);

                httpClient.get(url, params).then((res) => {
                    this.setMeta(res.meta);
                    this.trips = res.data.trips;
                    this.localTripsLoaded = this.trips.length > 0;
                    this.filteredSearch = false;
                    this.initialized = true;
                    if (!this.localTripsLoaded) {
                        this.fetchAllTrips();
                    }
                });
            },
            fetchAllTrips() {
                /* this.setLastFetch(2, null, null, null);
                let params = this.getParams(null, null, null);
                httpClient.get("/api/trips", params).then((res) => {
                    this.setMeta(res.meta);
                    this.trips = res.data.trips;
                    this.localTripsLoaded = false;
                    this.filteredSearch = false;
                    this.initialized = true;
                }); */

                this.$emit('clearForm')
            },
            filteredTripFetch(from, to, dateRange) {
                let url = this.getUrl(from, to);
                let params = this.getParams(from, to, dateRange);
                this.filteredSearchWithoutDate = dateRange && dateRange.length > 0 ? dateRange[0] == null : true
                if (!this.anySearchWasPerformedToday()) {
                    this.incrementStatistic('UNIQUE_SEARCHES_DAILY')
                    this.saveSearchDate()
                }
                httpClient.get(url, params).then(async (res) => {
                    this.setMeta(res.meta);
                    if (this.trips && res.data.trips.length > 0) {
                        this.incrementStatistic('SEARCHES_DAILY');
                        if (!this.anySuccessfulSearchWasPerformedToday()) {
                            this.incrementStatistic('UNIQUE_SUCCESS_SEARCHES_DAILY')
                            this.saveSuccesfulSearchDate()
                        }
                        this.setLastFetch(3, from, to, dateRange);
                        this.trips = res.data.trips;
                        // this.hasTrips = true;
                        this.filteredSearch = true;
                        this.setSearchTitle(this.$parent.searchForm.airportFrom, this.$parent.searchForm.airportTo);
                        // this.hasTrips = Boolean(this.trips && this.trips.length > 0);
                        this.localTripsLoaded = false;
                        this.initialized = true;
                    } 
                    else {
                        if (this.authenticated) {
                            this.airportsFrom = res.meta.airports_from;
                            this.airportsTo = res.meta.airports_to;
                            // this.showFailedSearchModal = true;
                        }
                        if (from && to && dateRange.length > 0 ) {
                            this.displayDinamicSwal(this.noFlightsPopUpCode, {
                                confirmButtonText: 'Yes',
                                cancelButtonText: 'No'
                            }).then(() => {
                                this.setLastFetch(3, from, to, dateRange);
                                this.proposeFailedSearch()
                                }
                            )
                            .catch(() => {
                                axios.post('/api/statistics', {name: 'REJECT_TRIP_CREATION'});
                                // this.fetchAllTrips();
                                this.$emit('clearForm');
                            });
                        }
                        else {
                            this.$swal.fire({
                            title: this.getPopUpTitle('no-flights-found-not-propose'),
                            html:this.getPopUpBody('no-flights-found-not-propose'),
                            icon:'info',
                            confirmButtonText: 'Ok',
                        }).then(() => {
                            this.$emit('clearForm');
                        })
                        }
                    }
                    this.localTripsLoaded = false;
                    this.initialized = true;
                });
            },
            proposeFailedSearch() {                
                this.showProposeATrip = true
            },
            storeFailedSearch(proposedTripParams) {
                let params = this.getFailedSearchParams(proposedTripParams)
                httpClient.post('/api/proposed-trip/failed-search', params).then( async (res) => {
                    if (!this.guestSetted || this.email != proposedTripParams.formData.email || this.phone != proposedTripParams.formData.phone ) {
                        this.setGuest(proposedTripParams.formData.email, proposedTripParams.formData.phone)
                    }
                    this.errorMessages = []
                    this.failedSearchNewTrip = res.data
                    this.showProposeATrip = false;
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_SUBMITTED_DAILY'})
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_SUBMITTED'})
                    axios.post('/api/statistics', {name: 'CONFIRMED_TRIP_CREATION'});
                    if (this.failedSearchNewTrip.tripStatus == this.getStatus('private') || this.failedSearchNewTrip.tripStatus == this.getStatus('shared-private')) {
                        this.$swal({
                            title: this.getPopUpTitle('after-private-proposed-trip-creation'),
                            icon: 'question',
                            html: this.getPopUpBody('after-private-proposed-trip-creation'),
                            confirmButtonText: 'Yes',
                            confirmButtonColor: '#2597d8',
                            cancelButtonText: 'No',
                            cancelButtonColor: '#1a2d74',
                            showCancelButton: true,
                        })
                        .then((res) => {
                            //Log In
                            if (res.isConfirmed) {
                                window.location.replace(process.env.VUE_APP_HOME_PAGE)
                            }
                            else {
                                httpClient.patch('/api/trip/'+this.failedSearchNewTrip.id,{ status: this.getStatus('verified') })
                                    .then(()=>{
                                        window.location.replace(process.env.VUE_APP_HOME_PAGE)
                                })
                            }
                        })
                    }
                    else {
                        await this.displayDinamicSwal(this.tripCreatedPopUpCode, {icon: 'success'})
                            .then(()=> {
                            window.location.replace(process.env.VUE_APP_HOME_PAGE)
                        })
                    }

                })
                .catch((err)=> {
                    // console.log(err.response.data)
                    const errors = err.response.data.errors
                    let fields = Object.keys(errors)
                    this.errorMessages = fields.map(field => errors[field][0])
                    // console.log(this.errorMessage)
                    })
            },
            keepSearching() {
                // this.showFailedSearchModal = false;
                this.$emit('clearForm');
                this.fetchAllTrips();
            },
            notifySimilarFlight() {
                // this.showFailedSearchModal = false;
                this.$emit('similarFlightNotification');
            },
            proposeATrip(status) {
                // this.showFailedSearchModal = false;
                this.proposeFailedSearch(this.lastFetch.from, this.lastFetch.to, this.lastFetch.dateRange, status)
                axios.post('/api/statistics', {name: 'CONFIRMED_TRIP_CREATION'});
            },
            setLastFetch(endpoint, from, to, dateRange) {
                this.lastFetch.endpoint = endpoint;
                this.lastFetch.from = from;
                this.lastFetch.to = to;
                this.lastFetch.dateRange = dateRange;
            },
            setSearchTitle(from, to) {
                this.searchTitle = '';
                if (from && to) {
                    this.searchTitle = 'Flights from ' + from.name + " (" + from.fid
                        + ") to " + to.name + ' (' + to.fid + ")";
                } else if (from && !to) {
                    this.searchTitle = 'Flights from ' + from.name + " (" + from.fid + ")";
                } else if (!from && to) {
                    this.searchTitle = 'Flights to ' + to.name + " (" + to.fid + ")";
                }
            },
            scrollToTop() {
                setTimeout(() => {
                    window.scroll({
                        top: 200,
                        left: 0,
                        behavior: 'smooth'
                    });
                }, 100)
            },
        },
        computed: {
            ...mapState('users', {
            user: state => state.user
            }),
            hasTrips: function () {
                return Boolean(this.trips && this.trips.length > 0);
            },

        },
        watch: {
            authenticated: function () {
                if (this.$store.state.users.user.airport_id && !this.initialized) {
                    this.fetchHomeAreaTrips();
                }
            },
            showProposeATrip(newVal) {
                if (newVal) {
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_ASKED'});
                    axios.post('/api/statistics', {name: 'GUESTS_SUBSCRIBE_ASKED_DAILY'});
                }
            }
        }
    }
</script>

<style>
</style>
